import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { exploreData } from '../../../utils/commonStatic';
import { getData, getCard, getSectionBox } from '../../../api/getDataStatic';
import CardPages from '../../CardPages/CardPages';
import SectionBoxCustom from '../../SectionBox/SectionBoxCustom';

export default function Photovoltaic() {
  const { t, i18n } = useTranslation();
  const [dataApi, setDataApi] = useState(null);
  const internalTitle = 'Photovoltaic';
  const title = 'photovoltaic';
  const [locale, setLocale] = useState(i18n.language);
  const [fetchingData, setFetchingData] = useState(true);

  const [card, setCard] = useState(null);
  const [box, setBox] = useState(null);

  useEffect(() => {
    i18n.on('languageChanged', (t) => {
      setFetchingData(true);
      setLocale(t);
    });
    setBox(null);

    setDataApi(null);

    try {
      const fetchData = async () => {
        const res = await getData({
          locale: locale,
          internalTitle: internalTitle,
        });

        const resCard = await getCard({
          locale: locale,
          internalTitle: internalTitle,
          title: title,
        });
        const resBox = await getSectionBox({
          locale: locale,
          internalTitle: internalTitle,
          title: title,
        });

        setBox(resBox);
        console.log(exploreData(res));
        setDataApi(exploreData(res));
        setCard(resCard);
      };

      if (fetchingData) {
        fetchData();
      }
      return () => setFetchingData(false);
    } catch (e) {
      console.log(e);
    }
  }, [fetchingData, locale, i18n]);

  return (
    <>
      <Helmet>
        <title>
          {t('common:app.name')} | {t('pages:photovoltaic.title')}
        </title>
      </Helmet>
      <CardPages
        slogan={dataApi?.photovoltaic?.slogan}
        title={dataApi?.photovoltaic?.textTitle}
        title2={dataApi?.photovoltaic?.text2Title}
        text={dataApi?.photovoltaic?.text}
        text2={dataApi?.photovoltaic?.text2}
        card={card}
        image={dataApi?.photovoltaic?.sloganImage}
        textImage={dataApi?.photovoltaic?.textImage}
        centalImage={dataApi?.photovoltaic?.centralImage}
      />
      <SectionBoxCustom dataSection={box} />
    </>
  );
}
